import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { ICharacter, AocClasses, getArchetype, AocArchetype } from '@pvplevelup/core/dist/interfaces/ICharacter';
import { Radar } from '@nivo/radar'
import {Sword} from 'components/SvgIcons/Sword';
import { Cross } from 'components/SvgIcons/Cross';
import { Shield } from 'components/SvgIcons/Shield';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import NumberFormat from 'react-number-format';

interface Props {
  character: ICharacter;
}

export enum RatingType {
  Offense = "Offense",
  Defense = "Defense",
  Support = "Support"
}

export const RadarLabel:(...args: any[]) => any = ({id, anchor}) => {
  return(
  <g transform={`translate(${anchor === 'end' ? -30 : anchor === 'middle' ? -15 : 0}, ${anchor === 'middle' ? -170 : -20})`}>
    {id == RatingType.Offense && <Sword width={25} style={{fill: 'rgb(116, 211, 209)'}} />}
    {id == RatingType.Defense && <Shield width={25} style={{fill: 'rgb(116, 211, 209)'}} />}
    {id == RatingType.Support && <Cross width={25} style={{fill: 'rgb(116, 211, 209)'}} />}
  </g>
)}

const useStyles = makeStyles((theme) => {
	return {
    characterName: {
      fontSize: '3em',
      letterSpacing: '0.05em',
      fontWeight: 500
    },
    characterClass: {
      fontSize: '1.2em',
      letterSpacing: '.1em',
      marginBottom: '1em'
    },
    justifySelf: {
      justifySelf: 'end'
    },
    valueGrid: {
      display: "grid",
      gridTemplateColumns: "auto 1fr",
      border: "1px solid #234d58",
      padding: "0.6em",
      gap: '.5em',
      fontSize: '1.2em',
      color: "#c9c9c9"
    },
    winlosegrid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)"
    },
    killdeathgrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr 2fr"
    },
    topkilldeathgrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr 2fr"
    },
    ccgrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr"
    },
    healgrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr"
    },
    damageGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr"
    },
    burstGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1fr 1fr"
    },
    value: {
      fontWeight: 'bold',
      color: "#fff"
    },
    noTop: {
      borderTop: 0
    },
    noRight: {
      borderRight: 0
    },
    graphs: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      justifyItems: 'center',
      color: 'black',
      marginTop:'1em'
    },
    radarLabel: {
      marginTop: '0.5em',
      color: 'white',
      fontSize: '1.5em',
      letterSpacing: '0.05em',
      fontWeight: 500
    }
	};
});
/*
const CharacterMatchmakingStats: React.FC<Props> = ({character}) => {
  const classes = useStyles();
  let data:any = [];
  let peakData:any = [];
  if(character.name){
    let totalGames = ((character.ranked?.wins || 0) + (character.ranked?.loses || 0) + (character.ranked?.ties || 0));
    let offenseObj: any = {"rating": RatingType.Offense}
    offenseObj[character.name] = (totalGames == 0 ? 0 : (character.ranked?.oRatings?.reduce((a,b)=>a+b) || 0) / totalGames)?.toFixed(4);
    let defenseObj: any = {"rating": RatingType.Defense}
    defenseObj[character.name] = (totalGames == 0 ? 0 : (character.ranked?.dRatings?.reduce((a,b)=>a+b) || 0) / totalGames)?.toFixed(4);
    let supportObj: any = {"rating": RatingType.Support}
    supportObj[character.name] = (totalGames == 0 ? 0 : (character.ranked?.sRatings?.reduce((a,b)=>a+b) || 0) / totalGames)?.toFixed(4);
    data = [offenseObj,defenseObj,supportObj];

    let peakoffenseObj: any = {"rating": RatingType.Offense}
    peakoffenseObj[character.name] = ((character.ranked?.peakORating?.length || 0) > 0 ? (character.ranked?.peakORating?.reduce((a,b)=>a+b) || 0) / (character.ranked?.peakORating?.length || 1) : 0)?.toFixed(4);
    let peakdefenseObj: any = {"rating": RatingType.Defense}
    peakdefenseObj[character.name] = ((character.ranked?.peakDRating?.length || 0) > 0 ? (character.ranked?.peakDRating?.reduce((a,b)=>a+b) || 0) / (character.ranked?.peakDRating?.length || 1) : 0)?.toFixed(4);
    let peaksupportObj: any = {"rating": RatingType.Support}
    peaksupportObj[character.name] = ((character.ranked?.peakSRating?.length || 0) > 0 ? (character.ranked?.peakSRating?.reduce((a,b)=>a+b) || 0) / (character.ranked?.peakSRating?.length || 1) : 0)?.toFixed(4);
    peakData = [peakoffenseObj,peakdefenseObj,peaksupportObj];
  }

	return (
    <div>
      <div className={classes.characterName}>
        {character.name}
      </div>
      <div className={classes.characterClass}>
        Lvl {character.level} {character.class}
      </div>
      {season &&
        <div className={classes.season}>
          <div className={classes.valueGrid}>
            <div>Mmr Rating</div>
            <div className={clsx(classes.justifySelf,classes.value)}>{season?.mmr}</div>
          </div>
          <div className={classes.winlosegrid}>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Wins</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.wins} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Loses</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.loses} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop)}>
              <div>Ties</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.ties} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
          </div>
          <div className={classes.killdeathgrid}>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Kills</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.kills} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Deaths</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.deaths} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Assists</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.assists} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop)}>
              <div>F Blows</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.fBlows} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
          </div>
          <div className={classes.topkilldeathgrid}>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Avg Kills</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.kills && character.ranked?.played || 0 > 0 ? (character.ranked?.kills || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Avg. Deaths</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.deaths && character.ranked?.played || 0 > 0 ? (character.ranked?.deaths || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Avg Assists</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.assists && character.ranked?.played || 0 > 0 ? (character.ranked?.assists || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop)}>
              <div>Avg F Blows</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.fBlows && character.ranked?.played || 0 > 0  ? (character.ranked?.fBlows || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
          </div>
          <div className={classes.ccgrid}>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>CCs</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.ccs && character.ranked?.played || 0 > 0 ? (character.ranked?.ccs || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div><Sword style={{width:'1em',fill:'#c9c9c9'}} /> CCs</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.oCCs && character.ranked?.played || 0 > 0 ? (character.ranked?.oCCs || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop)}>
              <div><Shield style={{width:'1em',fill:'#c9c9c9'}} /> CCs</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.dCCs && character.ranked?.played || 0 > 0 ? (character.ranked?.dCCs || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
          </div>
          <div className={classes.burstGrid}>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Avg Burst LTD</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.avgburstLtd && character.ranked?.played || 0 > 0 ? (character.ranked?.avgburstLtd || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Avg Burst LTK</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.avgburstLtk && character.ranked?.played || 0 > 0 ? (character.ranked?.avgburstLtk || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Peak Burst LTD</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.peakburstLtd && character.ranked?.played || 0 > 0 ? (character.ranked?.peakburstLtd || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop)}>
              <div>Peak Burst LTK</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.peakburstLtk && character.ranked?.played || 0 > 0 ? (character.ranked?.peakburstLtk || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
          </div>
          <div className={classes.damageGrid}>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Avg Damage</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.damage && character.ranked?.played || 0 > 0 ? (character.ranked?.damage || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
              <div>Avg Dmg Taken</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.dTaken && character.ranked?.played || 0 > 0 ? (character.ranked?.dTaken || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
            <div className={clsx(classes.valueGrid,classes.noTop)}>
              <div>Avg Dps</div>
              <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.dps && character.ranked?.played || 0 > 0 ? (character.ranked?.dps || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
            </div>
          </div>
          {getArchetype(character.class || "") == AocArchetype.Priest &&
            <div className={classes.healgrid}>
              <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
                <div>Avg Healing</div>
                <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.heal && character.ranked?.played || 0 > 0 ? (character.ranked?.heal || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
              </div>
              <div className={clsx(classes.valueGrid,classes.noTop,classes.noRight)}>
                <div>Effective Big Heals</div>
                <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.eBigHeal && character.ranked?.played || 0 > 0 ? (character.ranked?.eBigHeal || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
              </div>
              <div className={clsx(classes.valueGrid,classes.noTop)}>
                <div>Avg Hps</div>
                <div className={clsx(classes.justifySelf,classes.value)}><NumberFormat value={character.ranked?.hps && character.ranked?.played || 0 > 0 ? (character.ranked?.hps || 0) / (character.ranked?.played || 1) : 0} displayType={'text'} thousandSeparator={true} decimalScale={2} /></div>
              </div>
            </div>
          }
          <div className={clsx(classes.graphs,'graph-container')}>
            
            <Radar
              height={320}
              width={320}
              data={peakData}
              keys={[ character.name || "" ]}
              indexBy="rating"
              maxValue={1}
              margin={{ top: 0, right: 40, bottom: 0, left: 40 }}
              curve="linearClosed"
              borderWidth={1}
              borderColor={{ from: 'color', modifiers: [] }}
              gridLevels={1}
              gridShape="circular"
              gridLabelOffset={16}
              enableDots={false}
              dotSize={10}
              dotColor={{ theme: 'background' }}
              dotBorderWidth={2}
              dotBorderColor={{ from: 'color' }}
              enableDotLabel={true}
              dotLabel="value"
              dotLabelYOffset={-12}
              colors={{ scheme: 'category10' }}
              fillOpacity={0.5}
              blendMode="normal"
              animate={true}
              motionStiffness={90}
              motionDamping={15}
              isInteractive={true}
              gridLabel={RadarLabel}
              legends={[
              ]}
            />
            <Radar
              height={320}
              width={320}
              data={data}
              keys={[ character.name || "" ]}
              indexBy="rating"
              maxValue={1}
              margin={{ top: 0, right: 40, bottom: 0, left: 40 }}
              curve="linearClosed"
              borderWidth={1}
              borderColor={{ from: 'color', modifiers: [] }}
              gridLevels={1}
              gridShape="circular"
              gridLabelOffset={16}
              enableDots={false}
              dotSize={10}
              dotColor={{ theme: 'background' }}
              dotBorderWidth={2}
              dotBorderColor={{ from: 'color' }}
              enableDotLabel={true}
              dotLabel="value"
              dotLabelYOffset={-12}
              colors={{ scheme: 'category10' }}
              fillOpacity={0.5}
              blendMode="normal"
              animate={true}
              motionStiffness={90}
              motionDamping={15}
              isInteractive={true}
              gridLabel={RadarLabel}
              legends={[
              ]}
            />
          </div>
        </div>
      }
    </div>
	);
};

export {CharacterMatchmakingStats};
*/

//<div className="character-btn-text">{character.name}</div>